<template>
  <UtilitySwiper :autoplay="true" :pagination="true" :navigation="true" class="lg:h-[645px]">
    <swiper-slide v-for="slide in slides" :key="slide.documentId" class="aspect-video">
      <UtilityImage :src="slide.url" :alt="slide.name" class="w-full h-full" image-class="object-cover" />
    </swiper-slide>
  </UtilitySwiper>
</template>
<script setup lang="ts">
defineProps({
  slides: Array,
})
</script>
